module.exports = __webpack_public_path__ + "img/world.1c087908.svg";